import { FC, ReactElement, SyntheticEvent } from 'react';
import { Box, Button, Popover, PopoverTrigger, PopoverContent, PopoverBody, useDisclosure } from '@chakra-ui/react';
import { CbNavigationLink } from './CbNavigationLink';
import { CbNavigationSubLink } from './CbNavigationSubLink';
import { CbAvatar } from '../CbAvatar';
import { NavigationLink } from '../../types/Navigation';
export interface CbNavigationProfilePopoverProps {
  hasProfileImage: boolean;
  icon?: ReactElement;
  imageUrl?: string;
  name?: string;
  isActive: boolean;
  label: string;
  subLinks?: NavigationLink[];
  onClick?: (event: SyntheticEvent) => void;
}
export const CbNavigationProfilePopover: FC<CbNavigationProfilePopoverProps> = ({
  hasProfileImage,
  icon,
  imageUrl,
  name,
  isActive,
  label,
  subLinks,
  onClick
}) => {
  const {
    isOpen,
    onOpen,
    onClose
  } = useDisclosure();
  const handleLinkClick = (clickHandler, event) => {
    if (clickHandler) clickHandler(event);
    onOpen();
  };
  const handleSubLinkClick = (clickHandler, event) => {
    if (clickHandler) clickHandler(event);
    onClose();
  };
  const borderColor = hasProfileImage ? 'cloud.300' : 'luigisPants.400';
  const linkColor = hasProfileImage ? 'cloud.800' : 'cloud.500';
  const linkActiveColor = hasProfileImage ? 'luigisPants.500' : 'white';
  const hoverStyles = hasProfileImage ? {
    backgroundColor: 'cloud.300',
    textDecoration: 'none'
  } : {
    backgroundColor: 'transparent',
    color: 'white',
    textDecoration: 'none'
  };
  const trigger = hasProfileImage ? <Button colorScheme="transparent" padding="0" position="relative" onClick={event => handleLinkClick(onClick, event)} _focus={{
    border: 'none'
  }}>
        <CbAvatar avatarSize="md" borderRadius="50%" borderWidth="4px" borderColor="white" name={name} image={imageUrl} />
      </Button> : <CbNavigationLink backgroundColor="luigisPants.600" borderRadius={8} color={isOpen || isActive ? 'white' : 'cloud.500'} display="flex" alignItems="center" isActive={isActive} icon={icon} paddingX="16px" paddingY="10px" renderAsButton width="142px" onClick={event => handleLinkClick(onClick, event)}>
        {label}
      </CbNavigationLink>;
  return <Popover isOpen={isOpen} onClose={onClose} placement="bottom-end" data-sentry-element="Popover" data-sentry-component="CbNavigationProfilePopover" data-sentry-source-file="CbNavigationProfilePopover.tsx">
        <PopoverTrigger data-sentry-element="PopoverTrigger" data-sentry-source-file="CbNavigationProfilePopover.tsx">
          <Box data-sentry-element="Box" data-sentry-source-file="CbNavigationProfilePopover.tsx">{trigger}</Box>
        </PopoverTrigger>
        <PopoverContent border="none" boxShadow="0px 20px 100px rgba(0, 0, 0, 0.2)" minWidth={hasProfileImage ? '176px' : '142px'} borderRadius={8} marginTop={2} _focus={{
      boxShadow: '0px 30px 60px rgba(0, 0, 0, 0.1) !important',
      outline: 'none'
    }} data-sentry-element="PopoverContent" data-sentry-source-file="CbNavigationProfilePopover.tsx">
          <PopoverBody backgroundColor={hasProfileImage ? 'white' : 'luigisPants.600'} borderRadius={8} overflow="hidden" padding="0" data-sentry-element="PopoverBody" data-sentry-source-file="CbNavigationProfilePopover.tsx">
            {subLinks?.map((link, index) => <CbNavigationSubLink key={link.label} as={link.as} borderColor={borderColor} color={link.isActive ? linkActiveColor : linkColor} hasBorderBottom={index === subLinks.length - 1 ? false : true} href={link.href} isActive={link.isActive} isDisabled={link.isDisabled || false} icon={link.icon} paddingY={3} renderAsButton={link.renderAsButton} _hover={hoverStyles} _focus={hoverStyles} onClick={e => handleSubLinkClick(link.onClick, e)}>
                {link.label}
              </CbNavigationSubLink>)}
          </PopoverBody>
        </PopoverContent>
      </Popover>;
};